import React, { memo, MouseEvent, ReactNode, useEffect, useState } from 'react';
import { Box, Button, ButtonProps, ButtonPropsColorOverrides, Card, CardActions, CardContent, Collapse, SxProps } from "@mui/material";

export type BannerProps = {
    sticky?: boolean,
    isOpen?: boolean,
    appBarHeight?: number | string,
    onClose?: () => void,
    closeText?: string,
    color?: ButtonProps['color'] | ButtonPropsColorOverrides,
    message?: string,
    isAllowHtml?: boolean,
    content?: ReactNode | string,
    children?: ReactNode,
    prepend?: ReactNode,
    // child?: ReactNode,
    ButtonProps?: ButtonProps,
    actions?: {
        label: string,
        action: (ev?: MouseEvent) => void,
        ButtonProps?: ButtonProps,
    }[]
}
const Banner = ({ isOpen = false, appBarHeight = 0, color, onClose = () => { }, content = '', children, closeText, ButtonProps = {}, actions, sticky = false, prepend, message = '', isAllowHtml, ...props }: BannerProps) => {
    const [open, setOpen] = useState(isOpen);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen])

    return (
        <Collapse in={open} sx={{
            position: sticky ? 'sticky' : undefined,
            top: appBarHeight,
            zIndex: 1,
        }}>
            {!!children ? children : (
                <Card square sx={{
                    // position: 'sticky',
                    backgroundColor: !!color ? `var(--v-palette-${color}-main, --v-palette-background-paper)` : 'var(--v-palette-background-paper)',
                    color: !!color ? `var(--v-palette-${color}-contrastText, --v-palette-background-paper)` : 'var(--v-palette-text-primary)',
                }}>
                    <CardContent sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                    }}>
                        {!!content ? content : (
                            <>
                                <Box sx={{ mr: !!prepend ? 2 : undefined }}>{!!prepend ? prepend : ''}</Box>
                                <Box flexGrow={1}>{isAllowHtml ? <div dangerouslySetInnerHTML={{ __html: message }} /> : message}</Box>
                            </>
                        )}
                    </CardContent>
                    <CardActions disableSpacing={false} className={'justify-end'}>
                        {!!actions && !!actions.length ? (
                            <>
                                {actions.map((action, index) => {
                                    return (
                                        <Button key={index} {...ButtonProps} {...action?.ButtonProps || {}}
                                            onClick={(ev) => {
                                                if (!!action.action) action.action(ev);
                                            }}>
                                            {action?.label || ''}
                                        </Button>
                                    )
                                })}
                            </>
                        ) : (
                            <Button {...ButtonProps} size={ButtonProps?.size || 'medium'} onClick={() => {
                                setOpen(!open);
                                onClose();
                            }}>{closeText || 'Close'}</Button>
                        )}
                    </CardActions>
                </Card>
            )}
        </Collapse>
    )
}

export default memo(Banner);